module.exports = __webpack_public_path__ + "img/1alB-e-de.6c04a44b.jpg";